import { singletonFactory } from '@warehouse/shared/util';
import { EditPreventerRepository } from './EditPreventer.repository';
import { LocalStorageEditPreventerRepository } from './EditPreventer.repository.localStorage';

export const editPreventerRepositorySingleton = singletonFactory<EditPreventerRepository>({
	factory: () => new LocalStorageEditPreventerRepository(),
});
